import { useMutation, useQuery } from '@tanstack/react-query';
import { apiClient } from './client';
import type { SettlementResponse, UploadResponse } from '@/types/api';

export interface SettlementDataParams {
  start_date: string;
  end_date: string;
  granularity: string;
  merge_units: boolean;
  units?: string[];
}

export function useSettlementData(params: SettlementDataParams) {
  return useQuery({
    queryKey: ['settlement', 'data', params],
    queryFn: async () => {
      const res = await apiClient.get<SettlementResponse>('/settlement/data', {
        params: {
          start_date: params.start_date,
          end_date: params.end_date,
          granularity: params.granularity,
          merge_units: params.merge_units,
          units: params.units,
        },
        paramsSerializer: { indexes: null },
      });
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
    enabled: !!params.start_date && !!params.end_date,
  });
}

export interface SettlementUploadParams {
  file: File;
}

export function useSettlementUpload() {
  return useMutation({
    mutationFn: async (params: SettlementUploadParams) => {
      const formData = new FormData();
      formData.append('file', params.file);
      const res = await apiClient.post<UploadResponse>('/settlement/upload', formData);
      return res.data;
    },
  });
}
